import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const sizesGetRequest = simpleAction(TYPES.SIZES_GET_REQUEST);

/**
 * Request sizes success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const sizesGetSuccess = simpleAction(TYPES.SIZES_GET_SUCCESS);

/**
 * Request sizes error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const sizesGetError = simpleAction(TYPES.SIZES_GET_FAIL);
